//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
// import './style.scss';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Check } from 'src/onboarding/components/ui/check/Check';
import { Option } from 'src/onboarding/components/ui/check/Option';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const vegetableIntake = useStore((state) => state.vegetableIntake);
  const setVegetableIntake = useStore((state) => state.setVegetableIntake);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.vegetableIntake.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={vegetableIntake}
          onChange={(value) => {
            setVegetableIntake(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'vegetable-intake',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'None or a little'}>{t('onboarding.vegetableIntake.options.none')}</Option>
          <Option value={'In half of the meals'}>
            {t('onboarding.vegetableIntake.options.half')}
          </Option>
          <Option value={'Each meal'}>{t('onboarding.vegetableIntake.options.each')}</Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
